// Copyright (c) Hamilton Manufacturing Corp.
import React, { useEffect, useState } from 'react';
import QRCode from '../../_common/api/QRCode';
import { QuestRoute } from '../../_common/api/QuestRoutes';
import Cart from '../../_common/Cart';
import Button from '../../_common/form/Button';
import { useGlobalState } from '../../_common/globalState/GlobalStateProvider';
import Modal from '../../_common/Modal';
import Card from '../Card';
import airPAY from '../../../assets/images/airPAY.png';
import CountDown from '../../_common/CountDown';
import styled from 'styled-components';
import Loading from '../../_common/Loading';
import { HamQuest } from '../../../App';

const PaddedDiv = styled.div`
    padding: 0.5em 0;
`;

const AirPay = () => {
    const { state: {
        active_user,
        site_config
    } } = useGlobalState();

    const needsCardToUseAirPay = !active_user.payment || !active_user.payment.onFile;

    const [token, setToken] = useState(false)
    const [expireTime, setExpireTime] = useState(30);

    const generateToken = () => {
        setToken(false);
        HamQuest.post(QuestRoute.tempToken, {
            TempIdType: 'TempToken'
        })
            .then((res) => {
                if (!res.tempId) throw res.error;
                if (res.expirationTime > 0) setExpireTime(res.expirationTime);
                setToken(res.tempId);
            })
            .catch(ex => {
                console.log(ex);
                Modal.Show({
                    type: 'error',
                    title: 'Unable to Generate Token',
                    body: ex.blob || 'Sorry, something went wrong. Please try again.'
                });
            });
    }

    useEffect(() => {
        if (needsCardToUseAirPay) return;
        generateToken();
    }, [needsCardToUseAirPay])

    const handleAddCardToAccount = async () => {
        try {
            await Cart.AddCardToAccount();
        } catch (error) {
            if (
                error?.message !== 'Email verification required before adding a card.' &&
                error?.message !== 'Card tokenization cancelled.'
            ) {
                console.error('Unable to add card to account', error);
            }
        }
    }

    return (
        <Card title={site_config.airPayName ?? 'AirPay'} icon='QRcode'>

                {needsCardToUseAirPay ?
                    <>
                        <img src={airPAY} alt='AirPAYimg' />
                        <br />
                        <PaddedDiv>
                            <b>{site_config.airPayName ?? 'AirPay'}</b> gives you a quick and easy way to purchase services at our {site_config.companyName} locations. It's much like swiping a credit card only more secure! <br />
                            Once you register your credit/debit card with is, simply tap the {site_config.airPayName ?? 'AirPay'} button whenever you are ready to buy a wash. <br />
                            A unique code will be generated for you, which can then be scanned at the barcode reader of any of our kiosks. <br />
                            Your payment method will be charged and your service will then begin! A receipt is automatically emailed to you with every transaction.
                        </PaddedDiv>
                        <Button onClick={handleAddCardToAccount}>Set Up {site_config.airPayName ?? 'AirPay'}</Button>
                    </> :
                    token ?
                        <>
                            <QRCode data={token} live expireTime={expireTime} />
                            <CountDown type='bar' time={expireTime} callback={() => setToken(null)} />
                            <PaddedDiv>
                                It's much like swiping a credit card only more secure! The card you have registered with us will be charged for this transaction.
                            </PaddedDiv>
                        </> : token === false ?
                            <Loading /> :
                            <>
                                <PaddedDiv>Token expired. Please generate a new token to use {site_config.airPayName ?? 'AirPay'}.</PaddedDiv>
                                <Button onClick={() => generateToken()}>Generate a new Token</Button>
                            </>
                }
        </Card>
    );
}

export default AirPay;